import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {LoginServices} from "../../../auth/login/services/login.service";
import {getUrl} from "../../services/utils-service";

const publicApis: string[] = ['/api/v1.0/auth/token','cloud-functions-api-gw-config-926xrm2x.wl.gateway.dev'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private loginServices: LoginServices) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const urlWithoutParams = getUrl(req);
        if (urlWithoutParams == null) {
            return next.handle(req); // ignore invalid urls
        }
        if (publicApis.some((url) => urlWithoutParams.includes(url))) {
            console.log(`current url ->${urlWithoutParams}`);
            return next.handle(req); // no auth.
        } else {//sign with bearer token.
            if (this.loginServices.session()?.token) {
                const newRequest = req.clone({
                    setHeaders: {
                        'Authorization': `Bearer ` + this.loginServices.session()?.token
                    }
                });
                console.log(`bearer signed url ->${urlWithoutParams}`);
                return next.handle(newRequest);
            } else {
                return next.handle(req); // ignore invalid urls
            }
        }
    }
}
